import { render, staticRenderFns } from "./chatbot.vue?vue&type=template&id=42a9a3a5"
import script from "./chatbot.vue?vue&type=script&lang=js"
export * from "./chatbot.vue?vue&type=script&lang=js"
import style0 from "./chatbot.vue?vue&type=style&index=0&id=42a9a3a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports